import React, { useState, useEffect, Fragment, useRef } from "react";
import { getEvents } from "services/getEvents";
import CardEventSlider from "components/cardEventoSlider/cardEventSlider";
import './slider.sass';
import Loading from "components/loading/loading";
import { LEGAL_PATROCINADOR_CALIENTE, LEGAL_PATROCINADOR_CODERE } from "constantes/constantes";
import Legal from "components/legal/legal";

export default function SliderPrincipal({ flagMomios, url, patrocinador }) {

    const [data, setData] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [isEndReached, setIsEndReached] = useState(false);
    const sliderRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 780);
    const [loading, setLoading] = useState(true);
    const [newWidth, setNewWidth] = useState(0);

    //-- variables
    let ancho = 245; //330
    const principales = "principales";
    const automatico = "principales/principales_automatico";
    const manual = "principales/principales_manual";
    const semanal = "principales/principales_semanal";

    const updateMobileStatus = () => {
        setIsMobile(window.innerWidth <= 780);
        setNewWidth(window.innerWidth)
    };

    useEffect(() => {
        window.addEventListener('resize', updateMobileStatus);

        return () => {
            window.removeEventListener('resize', updateMobileStatus);
        };
    }, []);

    useEffect(() => {
        if (isMobile) {
            ancho = 245; //220
        }
        else {
            ancho = 245; //330
        }
    }, [isMobile])

    // realiza la peticion al servicio para la carga de informacion
    useEffect(() => {
        const fetchData = async () => {
            let endpoint;

            const lowerUrl = String(url).toLowerCase();
            const lowerPrincipales = String(principales).toLowerCase();

            if (lowerUrl.includes(lowerPrincipales) && lowerUrl.includes('principales_unotv')) {
                endpoint = "principales_unotv";
            } 
            else if (lowerUrl.includes(lowerPrincipales)) {
                endpoint = manual;
            } else {
                endpoint = url;
            }

            try {
                let response = await getEvents({ endpoint });
                let responseData = response.data;

                if (lowerUrl.includes(lowerPrincipales) && lowerPrincipales !== 'principales_unotv' && response) {
                    if (responseData.length === 0) {
                        endpoint = automatico;
                        response = await getEvents({ endpoint });
                        responseData = response.data;
                    }
                    if (String(endpoint).toLowerCase().includes(String('automatico').toLocaleLowerCase()) && responseData.length < 5) {
                        endpoint = semanal;
                        response = await getEvents({ endpoint });
                        responseData = response.data;
                    }
                }

                setLoading(false);
                setData(responseData);

            } catch (error) {
                console.error("Error al obtener los datos:", error);
            }
        };

        fetchData();
    }, [url]);

    // detecta que exista data y Encontra los elementos tiene current en true para desplazar hasta el primero     // setScrollLeft(firstTrueIndex * ancho);
    useEffect(() => {
        if (data.length > 0) {
            // Encontrar el primer índice cuyo elemento tiene current en true
            const firstTrueIndex = data.findIndex((item) => item.current);

            if (firstTrueIndex !== -1) {
                setCurrentIndex(firstTrueIndex);
                // Desplazar hacia la izquierda si hay elementos con current === false antes del primero con current === true
                if (firstTrueIndex > 0) {
                    sliderRef.current.scrollLeft = firstTrueIndex * ancho; // Ajusta el ancho de cada elemento según tu diseño
                }
            }
        }
    }, [data, loading]);

    useEffect(() => {
        if (data && data.length !== 0) {
            setLoading(false);
        }
    }, [data])

    // desplazamiento del slider mediante gestos táctiles
    const handleSwipe = () => {
        if (((touchStart - touchEnd) > 100) && currentIndex < data.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }

        if (((touchEnd - touchStart) > 100) && currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    // inicio desplazamiento toch
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    // desplazamiento touch en el eje x
    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    // click boton arrow left / right (desplazar a la izquierda y a la derecha)
    useEffect(() => {
        // if (!loading) {
        const handleScroll = () => {
            if (sliderRef.current) {
                setScrollLeft(sliderRef.current.scrollLeft);
            }

            const container = sliderRef.current;
            if (!container) return;

            let scrollLeft = container.scrollLeft;
            let containerWidth = container.clientWidth;
            let scrollWidth = container.scrollWidth;

            if ((scrollLeft + containerWidth) < (scrollWidth - 1))
                setIsEndReached(false);
            else
                setIsEndReached(true);
        };

        if (sliderRef.current) {
            sliderRef.current.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (sliderRef.current) {
                sliderRef.current.removeEventListener('scroll', handleScroll);
                setNewWidth(sliderRef.current?.clientWidth);
            }
        };
        // }
    }, [loading]);

    const moveScroll = (direction) => {
        const container = sliderRef.current;
        if (!container) return;

        const scrollLeftLocal = container.scrollLeft;
        const containerWidth = container.clientWidth;
        const itemWidth = container.querySelector('.container-card-evento-slider > *').clientWidth + 1;

        const itemsVisible = Math.floor(containerWidth / itemWidth);

        let move;
        if (direction === 'next') {
            let nextItemIndex = Math.ceil(scrollLeftLocal / itemWidth) + itemsVisible;
            move = nextItemIndex * itemWidth;
        } else {
            let prevItemIndex = Math.floor(scrollLeftLocal / itemWidth) - itemsVisible;
            move = prevItemIndex * itemWidth;
        }

        container.scrollTo({
            left: move,
            behavior: 'smooth'
        });
    };

    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const widgetoRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;
                setTimeout(() => {
                    window.requestAnimationFrame(() => {
                        const message = {
                            sentinel: "amp",
                            type: "embed-size",
                            height: newHeight,
                        };
                        window.parent.postMessage(message, "*");
                    });
                }, 300); // 500 ms de retraso
            });
        });

        if (widgetoRef.current) {
            resizeObserver.observe(widgetoRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [widgetoRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------
    // 


    return (
        <div className="container-sponsor" id="container-sponsor" ref={widgetoRef}>
            {loading && <Loading />}

            <div className={loading === false ? "container-slider-arrows" : "container-slider-arrows sliderNone"}  >

                {/* {scrollLeft >= ancho && */}
                {scrollLeft >= 1 &&
                    <button className="arrowL" onClick={() => moveScroll("prev")}></button>
                }

                <div className="container-slider" ref={sliderRef}>
                    <div
                        className="slides"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleSwipe}
                    >
                        {data && data.length > 0 && data.map((item, indice) =>
                            <Fragment key={item.id_juego}>
                                <CardEventSlider item={item} flagMomios={flagMomios} current={item.current} longitud={data.length} indice={indice} patrocinador={patrocinador} />
                            </Fragment>
                        )}
                    </div>
                </div>

                {/* {(!isEndReached && ( ((ancho * data.length) >= sliderRef.current?.clientWidth))) && */}
                {(!isEndReached && (((ancho * data.length) >= newWidth))) &&
                    <button className="arrowR" onClick={() => moveScroll("next")} ></button>
                }
            </div>

            {(flagMomios === true || flagMomios === "true") && !loading && (() => {
                const legalTextMap = {
                    codere: LEGAL_PATROCINADOR_CODERE,
                    caliente: LEGAL_PATROCINADOR_CALIENTE
                };

                const legalText = legalTextMap[patrocinador.toLowerCase()] || "";

                return legalText.trim().length > 0 ? <Legal patrocinador={patrocinador} /> : null;
            })()}
        </div>
    )
}
